import { Flex, Image, useColorMode } from '@chakra-ui/react';

import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getBookListPagePath } from '../../App';
import AutoComplete from '../../components/auto-complete';
import Button from '../../components/button';
import Layout from '../../components/layout';
import Text from '../../components/text';
import { useSession } from '../../hooks/useSession';
import SwalService from '../../services/swal';
import { ISelectOption } from '../../types';
import { IBookSelectOption } from './select-root';

export interface ISelectLocationsProps {
    selectedState: ISelectOption | null;
    selectedCountry: ISelectOption | null;
    setSelectedCountry: (countryOption: ISelectOption) => void;
    setSelectedState: (countryOption: ISelectOption) => void;
    countryOptions: ISelectOption[];
    getDisplayRegions: (selectedCountry: ISelectOption) => ISelectOption[];
    bookOptions: IBookSelectOption[];
}

export default function SelectLocations(props: ISelectLocationsProps) {
    const {
        selectedState,
        selectedCountry,
        setSelectedCountry,
        countryOptions,
        setSelectedState,
        getDisplayRegions,
        bookOptions,
    } = props;
    const session = useSession();
    const { push } = useHistory();
    const { colorMode, toggleColorMode } = useColorMode();

    useEffect(() => {
        if (
            session?.uiMode &&
            session?.uiMode != 'system' &&
            session?.uiMode != colorMode
        )
            toggleColorMode();
    }, []);

    //auto scroll to top of page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Layout
            colorMode={colorMode}
            alert={session?.user?.isSandbox ? 'SANDBOX MODE' : ''}
            buttons={
                <Button
                    isDisabled={!selectedState || !selectedCountry}
                    onClick={() => {
                        if (bookOptions.length > 0) {
                            push(
                                getBookListPagePath(
                                    session?.cid!,
                                    selectedState?.value!
                                )
                            );
                        } else {
                            SwalService.noBookForLocationSwal();
                        }
                    }}
                    w="full"
                >
                    Continue
                </Button>
            }
            hasBackButton={session?.user?.backButton}
        >
            <Flex
                direction="column"
                align="center"
                gap="32px"
                w="full"
                textAlign="center"
            >
                {session?.logoUrl && (
                    <Image
                        maxH="80px"
                        maxW="200px"
                        src={session?.logoUrl || ''}
                        alt="Sharp Sports"
                    />
                )}
                <Text maxW="280px">
                    Please choose a sportsbook to link with{' '}
                    {session?.user?.name}
                </Text>
                <Flex direction="column" gap="24px" w="full" mb="40px">
                    <AutoComplete
                        value={selectedCountry}
                        onChange={(value: any) =>
                            setSelectedCountry(value as ISelectOption)
                        }
                        placeholder="Select your Country"
                        options={countryOptions}
                        colorMode={session?.uiMode}
                        size="lg"
                    />
                    <AutoComplete
                        placeholder="Select your state"
                        isDisabled={!selectedCountry}
                        value={selectedCountry && selectedState}
                        onChange={(value: any) =>
                            selectedCountry &&
                            setSelectedState(value as ISelectOption)
                        }
                        options={
                            (selectedCountry &&
                                getDisplayRegions(selectedCountry)) ||
                            []
                        }
                        colorMode={session?.uiMode}
                        size="lg"
                    />
                </Flex>
            </Flex>
        </Layout>
    );
}
